import FieldEditor from "editor/FieldEditor";
import Ajax from "base/Ajax";
import Modal from "modal/Modal";
import FormValidator from "base/FormValidator";

class CategoriesEditor extends FieldEditor {
    create() {
        this.loaded = false;
        this.value = [];
        this.load();
    }

    static get_categories(id) {
        if ("undefined" !== typeof CategoriesEditor.categories_cache[id]) return Promise.resolve(CategoriesEditor.categories_cache[id]);

        return Ajax.get('content', 'categories/' + id).then((categories) => {
            CategoriesEditor.categories_cache[id] = categories;

            return categories;
        });
    }

    load() {
        let prom = CategoriesEditor.get_categories(this.$element.attr("data-id")).then((categories) => {
            this.categories = categories;
            this.loaded = true;
            let selectedIds = this.value.map((item) => {
                if ("object" === typeof item) return item.id;

                return item;
            });

            if (categories.length === 1 && !this.settings.allowMultiple) {
                let category = categories[0];
                this.$element.html(
                    eotwJSXFactory('label', {class: "admin-form__label admin-form__label--smargin"}, [
                        eotwJSXFactory('input', {class: "admin-form__checkbox js-category", type: "checkbox", name: this.$element.attr("data-name") + (this.settings.allowMultiple ? "[]" : ""), value: category.id, checked: selectedIds.indexOf(category.id) !== -1, 'data-optional': true}),
                        category.name
                    ])
                );
            } else {
                this.$element.html(categories.map((category) => this.buildCategoryInput(category)));
            }
            if (this.settings.allowAdding) {
                this.$element.append(
                    eotwJSXFactory('button', {class: "admin-form__prop admin-form__prop--add js-add-category", type: "button"}, [
                        eotwJSXFactory('span', null, ["Add"])
                    ])
                );

                this.$element.on("click", ".js-add-category", () => {
                    let currentModal = Modal.shownModals.length > 0 ? Modal.shownModals[0] : null;

                    let modal = new Modal({destroyOnClose: true});

                    if (currentModal instanceof Modal) {
                        modal.on("hide", () => currentModal.show());
                    }

                    let $form = (
                        eotwJSXFactory('form', {class: "admin-form"}, [
                            eotwJSXFactory('h1', null, ["Add a Category"]),
                            eotwJSXFactory('div', {class: "admin-form__col--full"}, [
                                eotwJSXFactory('div', {class: "admin-form__row"}, [
                                    eotwJSXFactory('label', {class: "admin-form__label", for: "category-name"}, ["Name"]),
                                    eotwJSXFactory('input', {class: "admin-form__input js-name", id: "category-name", name: "name"}),
                                    eotwJSXFactory('span', {class: "form__inline-validation js-inline-validation"})
                                ])
                            ]),
                            eotwJSXFactory('div', {class: "admin-form__col--full admin-modal__buttons"}, [
                                eotwJSXFactory('button', {class: "admin-btn admin-btn--confirm admin-btn--modal", type: "submit"}, ["Add"]),
                                eotwJSXFactory('button', {class: "admin-btn admin-btn--cancel admin-btn--modal js-cancel"}, ["Cancel"])
                            ])
                        ])
                    );

                    modal.setContent($form);

                    FormValidator.attach($form).on("submit", () => {
                        let category = {name: $form.find(".js-name").val()};
                        this.categories.push(category);
                        this.$element.find(".js-add-category").before(this.buildCategoryInput(category, true));

                        modal.hide();
                    });

                    modal.show();
                    return false;
                });
            }

            this.loaded = true;
            this.setValue(this.value);
        });

        this.emit("loading", prom);
    }

    buildCategoryInput(category, checked = false) {
        return (
            eotwJSXFactory('label', {class: "admin-form__prop js-category-label"}, [
                eotwJSXFactory('input', {type: this.settings.allowMultiple ? "checkbox" : "radio", class: "js-category", name: this.$element.attr("data-name") + (this.settings.allowMultiple ? "[]" : ""), value: category.id, checked: checked, 'data-name': category.name, 'data-optional': this.settings.required ? undefined : true}),
                eotwJSXFactory('span', null, [category.name])
            ])
        );
    }

    destroy() {
        super.destroy();
    }

    getValue() {
        if (this.loaded) {
            let categoryMap = {};
            this.categories.forEach((cat) => {
                if ('undefined' !== typeof cat.id) categoryMap[cat.id] = cat;
            });

            let val = this.$element.find(".js-category:checked").map(function () {
                if ($(this).is("[value]")) {
                    return categoryMap[$(this).attr("value")];
                } else {
                    return {
                        name: $(this).attr("data-name")
                    }
                }
            }).get();

            if (this.settings.allowMultiple) {
                return val;
            } else {
                return val.length > 0 ? [val[0]] : null;
            }
        } else {
            return this.value;
        }
    }

    getDefaultSettings() {
        return {
            allowMultiple: true,
            allowAdding: false,
            required: false
        }
    }

    setValue(value) {
        if (!(value instanceof Array)) value = [];

        this.value = value;

        if (this.loaded) {
            this.$element.find(".js-category").prop("checked", false);

            this.value.forEach((value) => {
                if ("string" === typeof value) {
                    this.$element.find(".js-category[value='" + value + "']").prop("checked", true);
                } else if ("undefined" !== typeof value.id) {
                    this.$element.find(".js-category[value='" + value.id + "']").prop("checked", true);
                } else {
                    this.$element.find(".js-category[data-name='" + value.name + "']").prop("checked", true);
                }
            });
        }
    }
}

CategoriesEditor.categories_cache = {};

FieldEditor.register_editor('categories', CategoriesEditor);

export default CategoriesEditor;
